import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import palette from '../../../../shared/lib/theme/palette';
import { ActionType } from '../../app/reducer/AppContextReducer';
import { EditContactNumber } from './EditContactNumber';
import { useAppContext } from '../../app/contexts/AppContext';
import { formatPhoneNumber } from '../../../../shared/lib/utils';
import { LABEL_PHONE_NUMBER, NOTE_YOUR_MOBILE_PHONE_NUMBER } from '../../../../shared/lib/constants';
import { withTrademark } from '../../../../shared/lib/common/Tokenizer';

export const EditUserContactNumber = () => {
  const { currentUser, isPhoneEdit, dispatch } = useAppContext();
  const { blackTwo, blackFive, blackOne } = palette;
  const { phoneNumber } = currentUser ?? {};
  const [hideBackDrop, setHideBackDrop] = useState<boolean>(false);

  const phoneEditOpen = () => {
    dispatch({ type: ActionType.SET_IS_PHONE_EDIT, isPhoneEdit: !isPhoneEdit });
    setHideBackDrop(true);
  };

  return (
    <Box borderBottom={`1px dashed ${blackFive}`} py="16px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center" gap="6px">
          <Typography variant="h2" sx={{ textTransform: 'uppercase', color: blackTwo }}>
            {LABEL_PHONE_NUMBER}
          </Typography>
          <Tooltip title={withTrademark(NOTE_YOUR_MOBILE_PHONE_NUMBER)} arrow placement="top-start">
            <InfoOutlinedIcon sx={{ fontSize: '1rem', color: blackTwo, cursor: 'pointer', opacity: 0.7 }} />
          </Tooltip>
        </Box>

        <IconButton color="primary" size="large" onClick={phoneEditOpen}>
          {isPhoneEdit ? <ArrowBackIcon /> : <EditIcon />}
        </IconButton>
      </Box>

      <Typography variant="body2" sx={{ color: { blackOne }, fontWeight: '600' }}>
        {formatPhoneNumber(phoneNumber ?? '') || <Skeleton width={200} />}
      </Typography>

      <EditContactNumber hideBackDrop={hideBackDrop} setHideBackDrop={setHideBackDrop} />
    </Box>
  );
};
